export const POSITION_OPTIONS = {
  positionsX: ['left', 'center', 'right'],
  positionsY: ['top', 'middle', 'bottom'],
};

export const CANVAS_SIZES = [50, 100, 200, 300, 400, 500, 600, 800, 1000];
